import { render, staticRenderFns } from "./accidents-filter.vue?vue&type=template&id=087aa3b6&"
import script from "./accidents-filter.vue?vue&type=script&lang=js&"
export * from "./accidents-filter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports